import APIClient from '@/shared/http/clients/api'

const resourceName = 'card'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const CreateCardAndPerson = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/person/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (boardColumnId = {}, situacao = 1, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardColumnId=${boardColumnId}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&${!sortValue.includes('sortDiasAtraso') ? 'sort=' : ''}${sortValue}`, config)
const SearchAllByDocument = (document = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}&sort=${sortValue}`, config)
const SearchByBoard = (boardId = {}, situacao = {}, filter = '', limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardId=${boardId}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&sort=posicao`, config)
const PatchSituacao = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}`, data, config)
const PatchLeadOwner = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}/update-leadowner`, data, config)
const SetLeadOwner = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/update-owners`, data, config)
const MoveCard = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/move-card/${data.id}`, data, config)
const MoveCardBoard = (id, data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/move-card-board/${id}`, data, config)
const Import = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/import-cards/`, data, config)
const VerifyIfExists = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/import-cards/validation`, data, config)
const GetAllReport = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)

const CardRepository = {
  GetAll,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  SearchAllByDocument,
  SearchByBoard,
  CreateCardAndPerson,
  PatchSituacao,
  MoveCard,
  MoveCardBoard,
  PatchLeadOwner,
  SetLeadOwner,
  Import,
  VerifyIfExists,
  GetAllReport
}

export default CardRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/card.js